import type { BrandingCardPlatform } from "../_types/branding.types";

export const BRANDING_SCOPE_OPTIONS = [
  { value: "all", label: "All scopes" },
  { value: "org", label: "Organization" },
  { value: "groups", label: "Groups" },
] as const;

export const BRANDING_STATUS_OPTIONS = [
  { value: "all", label: "All statuses" },
  { value: "draft", label: "Draft" },
  { value: "published", label: "Published" },
] as const;

export const BRANDING_PLATFORM_OPTIONS = [
  { value: "Windows", label: "Windows" },
  { value: "macOS", label: "macOS" },
  { value: "Android", label: "Android" },
  { value: "iOS", label: "iOS" },
  { value: "Linux", label: "Linux" },
  { value: "Web", label: "Web" },
] as const satisfies ReadonlyArray<{ value: BrandingCardPlatform; label: string }>;

export type BrandingScopeFilter = (typeof BRANDING_SCOPE_OPTIONS)[number]["value"];
export type BrandingStatusFilter = (typeof BRANDING_STATUS_OPTIONS)[number]["value"];
